import React, { useState, useEffect } from "react";
import Mynftpage from "../mynfts"
import { addDoc, Timestamp, collection, getDocs, setDoc, doc, query } from "firebase/firestore";
import { db } from "../firebase";


function NorthStaking() {
  const [firebaseData, setfirebaseData] = useState([])
  const [selectedZoneValue, setselectedZoneValue] = useState("")
  const getFirebasedata = async () => {
    const q = query(collection(db, "RewardInfo"));
    const querySnapshot = await getDocs(q);
    var temp = {}
    querySnapshot.forEach((doc) => {
      temp[doc.id] = Object.values(doc.data())[0]
    });
    setfirebaseData(temp)
  }

  useEffect(() => {
    getFirebasedata()
  }, [])

  useEffect(() => {
    if (window.location.pathname == "/northstake") {
      console.log("it is North zone", firebaseData.North);
      setselectedZoneValue(firebaseData.North)
    }
  }, [firebaseData])
  return (
    <div>
      <Mynftpage zone="north" reward={selectedZoneValue} />
    </div>
  );
}

export default NorthStaking;
